"use client"

import { useState } from "react"

type ClipboardWriter = { readonly writeText: (value: string) => Promise<void> }

export const copyCustomerNumber = async (value: string, writer?: ClipboardWriter): Promise<void> => {
  const clipboard = writer ?? navigator.clipboard
  await clipboard.writeText(value)
}

export const abbreviatedCustomerNumber = (value: string): string => (value.length <= 13 ? value : `${value.slice(0, 4)}…${value.slice(-4)}`)

export const CustomerNumberCopy = ({ presentation = "icon", value }: { readonly presentation?: "icon" | "text"; readonly value: string }) => {
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle")

  const copy = async () => {
    try {
      await copyCustomerNumber(value)
      setState("copied")
    } catch {
      setState("failed")
    }
  }

  const stateLabel = state === "copied" ? "고객번호 복사됨" : state === "failed" ? "고객번호 복사 다시 시도" : "고객번호 복사"

  return (
    <span className="customer-number-row" data-customer-number-presentation={presentation}>
      <span className="customer-number-value" title={value}>
        {presentation === "text" ? value : abbreviatedCustomerNumber(value)}
      </span>
      <button aria-label={stateLabel} className="customer-number-copy" data-copy-state={state} onClick={copy} title={stateLabel} type="button">
        {presentation === "text" ? (
          <span aria-hidden="true">{state === "copied" ? "복사됨" : state === "failed" ? "재시도" : "복사"}</span>
        ) : (
          <svg aria-hidden="true" className="customer-number-copy-icon" fill="none" viewBox="0 0 20 20">
            {state === "copied" ? (
              <path d="m4 10 3.5 3.5L16 5" />
            ) : (
              <>
                <rect height="10" rx="2" width="10" x="7" y="7" />
                <path d="M13 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
              </>
            )}
          </svg>
        )}
        <span aria-live="polite" className="visually-hidden">
          {stateLabel}
        </span>
      </button>
    </span>
  )
}
